$(document).ready(function () {
  function mapInit (latitude, longitude) {
    const mapModalAddress = L.map('modalMap').setView([latitude, longitude], 19);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(mapModalAddress);

    const icon = L.icon({
      iconUrl: 'https://cdn.shopify.com/s/files/1/0270/8255/5497/files/logo_3e9f25e4-8cd3-4845-bb60-c817d0d5d654.svg?v=1706700401',

      iconSize:     [68, 95],
      iconAnchor:   [30, 45],
      popupAnchor:  [-3, -76]
    });
    L.marker([latitude, longitude], {icon: icon}).addTo(mapModalAddress);
  }
  function addMarkUp (markUp) {
    $('.modal-universal__content').html(markUp)
  }
  function addressModalProcess () {
    const latitude = Number($(this).attr('data-latitude'));
    const longitude = Number($(this).attr('data-longitude'));
    const markUp = createMarkUp($(this))
    addMarkUp(markUp)
    modalOpen()
    mapInit(latitude, longitude)
  }
  function createMarkUp (el) {
    const address = el.attr('data-address')
    const phone = el.attr('data-phone')
    const openFirst = el.attr('data-open-h-first')
    const openSecond = el.attr('data-open-h-second')
    const productUrl = el.attr('data-product-url')
    const name = el.attr('data-name')
    const image = el.attr('data-image')
    const imageAlt = el.attr('data-image-alt') || 'Address image'
    const hoursLabel = el.attr('data-label-hours') || 'OPENING HOURS'
    const addressLabel = el.attr('data-label-address') || 'ADDRESS'
    const bookLabel = el.attr('data-label-book') || 'BOOK WORKOUT'
    const markUp = `
      <div class="addresses-modal">
        <h2 class="addresses-modal__title desktop">${ name }</h2>
        <div class="addresses-modal__wrapper">
          <div class="addresses-modal__left-col">
              <div class="addresses-modal__image-box">
                <img src="${image}" alt="${imageAlt}" class="addresses-modal__image">
              </div> 
              <h3 class="addresses-modal__small-title desktop">${hoursLabel}</h3> 
              <div class="open-text-desktop"> 
                <p class="addresses-modal__text">${openFirst}</p> 
                <p class="addresses-modal__text">${openSecond}</p> 
              </div> 
          </div> 
          <div class="addresses-modal__right-col"> 
              <h2 class="addresses-modal__title mobile">${ name }</h2>
              <div id="modalMap" class="addresses-modal__map"></div> 
              <h3 class="addresses-modal__small-title">${addressLabel}</h3>
              <div>
                <div style="display: flex; gap: 6px; align-items: center ">
                  <span class="locations-block__address-icon flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8.00002 8.33325C9.10459 8.33325 10 7.43782 10 6.33325C10 5.22868 9.10459 4.33325
                      8.00002 4.33325C6.89545 4.33325 6.00002 5.22868 6.00002 6.33325C6.00002 7.43782 6.89545 8.33325 8.00002 8.33325Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.00002 14.6666C9.33335 11.9999 13.3334 10.2788 13.3334 6.66659C13.3334 3.72107
                      10.9455 1.33325 8.00002 1.33325C5.0545 1.33325 2.66669 3.72107 2.66669 6.66659C2.66669 10.2788
                      6.66669 11.9999 8.00002 14.6666Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                  <p class="addresses-modal__text" style="margin-top: 0">${address}</p>
                </div>
              </div>
              <h3 class="addresses-modal__small-title" style="margin-top: 16px;">CONTACT</h3>
              <div style="display: flex; gap: 6px; align-items: center ;">
                <span class="locations-block__address-icon flex">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_582_11642)">
                      <path d="M9.36642 3.99992C10.0176 4.12696 10.616 4.44542 11.0851 4.91454C11.5542 5.38366
                      11.8727 5.9821 11.9998 6.63325M9.36642 1.33325C10.7193 1.48354 11.9808 2.08937 12.9439
                      3.05126C13.907 4.01315 14.5144 5.27393 14.6664 6.62659M6.81774 9.24196C6.01669 8.44091 5.38416
                      7.53515 4.92016 6.56874C4.88025 6.48561 4.8603 6.44405 4.84497 6.39145C4.79048 6.20455 4.82962
                      5.97505 4.94296 5.81676C4.97485 5.77222 5.01296 5.73411 5.08917 5.65791C5.32224 5.42483 5.43877
                      5.3083 5.51496 5.19111C5.80229 4.74919 5.80229 4.17947 5.51496 3.73754C5.43877 3.62035 5.32224 3.50382
                      5.08916 3.27075L4.95925 3.14084C4.60496 2.78654 4.42781 2.60939 4.23756 2.51316C3.85918 2.32178 3.41234
                      2.32178 3.03396 2.51316C2.84371 2.60939 2.66656 2.78654 2.31227 3.14084L2.20718 3.24593C1.8541 3.59901
                      1.67755 3.77555 1.54272 4.01557C1.39311 4.28191 1.28553 4.69557 1.28644 5.00105C1.28726 5.27635 1.34067
                      5.4645 1.44747 5.84079C2.02145 7.86306 3.10443 9.7713 4.69642 11.3633C6.28841 12.9553 8.19665 14.0383
                      10.2189 14.6122C10.5952 14.719 10.7834 14.7724 11.0587 14.7733C11.3641 14.7742 11.7778 14.6666 12.0441
                      14.517C12.2842 14.3822 12.4607 14.2056 12.8138 13.8525L12.9189 13.7474C13.2732 13.3931 13.4503 13.216
                      13.5465 13.0257C13.7379 12.6474 13.7379 12.2005 13.5465 11.8221C13.4503 11.6319 13.2732 11.4547 12.9189
                      11.1005L12.789 10.9705C12.5559 10.7375 12.4394 10.6209 12.3222 10.5447C11.8802 10.2574 11.3105 10.2574
                      10.8686 10.5447C10.7514 10.6209 10.6349 10.7375 10.4018 10.9705C10.3256 11.0467 10.2875 11.0849 10.2429
                      11.1167C10.0847 11.2301 9.85515 11.2692 9.66825 11.2147C9.61566 11.1994 9.57409 11.1795 9.49097 11.1395C8.52455
                      10.6755 7.61879 10.043 6.81774 9.24196Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_582_11642">
                        <rect width="16" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <p class="addresses-modal__text" style="margin-top: 0">${phone}</p>
              </div>
              <h3 class="addresses-modal__small-title mobile" style="margin-top: 16px;">${hoursLabel}</h3> 
              <div class="open-text-mobile"> 
                <p class="addresses-modal__text">${openFirst}</p> 
                <p class="addresses-modal__text">${openSecond}</p> 
              </div> 
            </div>
          </div>
        <a href="${productUrl}" class="addresses-modal__link custom-second-link flex">${bookLabel}</a>
      </div>`
    return markUp
  }
  function modalOpen () {
    $('body').addClass('hidden-overflow')
    $('.modal-universal').toggleClass('show')
  }
  $('.locations-block__btn').on('click',addressModalProcess)
})